<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content report-box  container-fluid">

      <div>
        <h1>{{ $store.getters.currentLanguage === 'en' ? 'Welcome' : 'Bienvenido' }}</h1>
      </div>
      <!-- Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <breadcrumbthree :title="title" :text="text" :text1="text1" />

          <div class="col-auto">
            <a
              class="btn add-user"
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#add_collaborator"
            >
              <i class="fas fa-plus"></i> Agregar Registro
            </a>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model = "searched_value"
                    @input="localSearch()"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableCollaborators"
                  :data-source="dataTableFiltCollaborators"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'parrafo'">
                        <div>{{ record.parrafo }}</div>
                    </template>
                    <template v-if="column.key === 'imagenUrl'">
                        <div><img :src="record.imagenUrl" style="max-width:64px"/></div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_collaborator"
                          @click="loadEditModalCollaborator(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_collaborator"
                          @click="loadDeleteModalCollaborator(record)"
                          ><i class="far fa-trash-alt"></i></a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_collaborator">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addCollaborator">
            <div class="form-group">
              <label>Párrafo</label>
              <textarea 
                class="form-control" 
                name="txt-parrafo" 
                style="min-height:140px" 
                placeholder="Párrafo"
                v-model="text_collaborator"
              >
              </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeCollaborator"
                />
              <div class="img-preview">
                <img :src="img_preview_collaborator"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->

  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_collaborator">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editCollaborator">
            <div class="form-group">
              <label>Párrafo</label>
              <textarea 
                class="form-control" 
                name="txt-parrafo" 
                style="min-height:140px"  
                placeholder="Párrafo"
                v-model="text_collaborator"
              >
              </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeCollaborator"
              />
              <div class="img-preview">
                <img :src="img_preview_collaborator"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_collaborator" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a 
                  href="javascript:void(0);" 
                  class="btn btn-agv-dos continue-btn" 
                  data-bs-dismiss="modal" 
                  @click="deleteCollaborator(record)"
                >
                Eliminar
                </a>
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->
</template>

<style>
    .ver-imagen{
        max-width: 100%;
        position: relative;
    }

    .ver-imagen button {
        position: absolute;
        right: 16px;
        top: 16px;
    }

    .img-preview{
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
    }

    .img-preview img{
      height: 100%;
    }

</style>

<script>

const fnbaseToCols = (column) => {
  return {
        title: column.title,
        dataIndex: column.dataIndex,
        key: column.dataIndex,
        sorter : false,
        class: column?.class ?? "" ,
    }
};

const baseColsTableCollaborators = [
  // { title: "N°", dataIndex: "index"},
  { title: "Texto", dataIndex: "text"},
  { title: "Imagen", dataIndex: "s3_url"},
  // { title: "Imagen", dataIndex: "photo"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableCollaborators = baseColsTableCollaborators.map ( fnbaseToCols );

import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
import { router } from "@/router";
const currentDate = ref(new Date());


export default {
  data() {
    return {
      columnsTableCollaborators,
      title: "Nuestros Colaboradores",
      text: "Mantenimientos Páginas",
      text1: "Nuestros Colaboradores",
      filterInputsDisplay: "none",
      startdate: currentDate,
      
      dataTableCollaborators: null,
      dataTableFiltCollaborators: null,
      id_collaborator: null,
      text_collaborator: null,
      img_collaborator: null,
      img_preview_collaborator: null,
      searched_value:null,

      language: null,
    };
  },
  mounted(){
    this.getCollaborators()
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userDataAdmin')) {
      router.push('/admin/login');
    }else{
      next()
    }
  },
  methods: {
    handlePhotoChangeCollaborator(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_collaborator = file;
        this.img_preview_collaborator= URL.createObjectURL(file);
      }
    },

    addCollaborator(){
      const yo = this       
      const formData = new FormData();
      formData.append('text', yo.text_collaborator);
      formData.append('img_value', yo.img_collaborator);
      formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createCollaborator/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          console.log(response.data)
          if (response.data['is_error'][0] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getCollaborators()
            yo.clearValuesColaborator()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getCollaborators(){
      const yo = this
      yo.dataTableCollaborators=[]
      yo.dataTableFiltCollaborators=[]
      const config = {
        method: 'get',
        url: '/talentoagv/readCollaborators/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableCollaborators.push(r)
                yo.dataTableFiltCollaborators.push(r)
              }
            }
            // yo.dataTableCollaborators = response.data['result']
            // yo.dataTableFiltCollaborators = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalCollaborator(datos){
      const yo = this
      yo.id_collaborator = datos['id']
      yo.text_collaborator = datos['text']
      yo.img_preview_collaborator = datos['s3_url']
    },

    editCollaborator(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_collaborator', yo.id_collaborator);
      formData.append('text_collaborator', yo.text_collaborator);
      if (yo.img_collaborator) {
        formData.append('img_collaborator', this.img_collaborator);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateCollaborator/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            // yo.clearValuesValue()
            yo.getCollaborators()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalCollaborator(datos){
      const yo = this
      yo.id_collaborator = datos['id']
    },

    deleteCollaborator(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_collaborator,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteCollaborator/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getCollaborators()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesColaborator(){
      const yo = this
      yo.id_collaborator=null
      yo.text_collaborator=null
      yo.img_collaborator=null
      yo.img_preview_collaborator=null
    },

    //-------------- Busqueda Local en Tabla --------------//

    localSearch(){
      const yo = this
      let data = yo.dataTableCollaborators
      let searched_value = yo.searched_value.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []
      
      // Recorrer cada objeto en la lista de datos
      for (let obj of data) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        yo.dataTableFiltCollaborators = resultados
      }else{
        yo.dataTableFiltCollaborators = yo.dataTableCollaborators
      }
    },

  },
};
</script>
